export enum WorkOrderStatus {
    Received = 'received',
    Rejected = 'rejected'
}
